export default {
    props: {
        attributes: {
            type: Object,
            default: undefined,
            kComposite: 'attributes'
        }, 
        columns: Array,
        command: {
            type: Array,
            default: undefined,
            kComposite: 'command'
        },         Editor: {
            type: Function,
            default: undefined,
            kComposite: 'editor'
        }, 
        encoded: {
            type: Boolean,
            default: undefined,
            kComposite: 'encoded'
        }, 
        expandable: {
            type: Boolean,
            default: undefined,
            kComposite: 'expandable'
        }, 
        field: {
            type: String,
            default: undefined,
            kComposite: 'field'
        }, 
        filterable: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable'
        }, 
        filterableUi: {
            type: [String, Function],
            default: undefined,
            kComposite: 'filterable.ui'
        }, 
        footerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'footerTemplate'
        }, 
        format: {
            type: String,
            default: undefined,
            kComposite: 'format'
        }, 
        headerAttributes: {
            type: Object,
            default: undefined,
            kComposite: 'headerAttributes'
        }, 
        headerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'headerTemplate'
        }, 
        minScreenWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minScreenWidth'
        }, 
        sortable: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable'
        }, 
        sortableCompare: {
            type: Function,
            default: undefined,
            kComposite: 'sortable.compare'
        }, 
        template: {
            type: [String, Function],
            default: undefined,
            kComposite: 'template'
        }, 
        title: {
            type: String,
            default: undefined,
            kComposite: 'title'
        }, 
        width: {
            type: [String, Number],
            default: undefined,
            kComposite: 'width'
        }, 
        hidden: {
            type: Boolean,
            default: undefined,
            kComposite: 'hidden'
        }, 
        menu: {
            type: Boolean,
            default: undefined,
            kComposite: 'menu'
        }, 
        locked: {
            type: Boolean,
            default: undefined,
            kComposite: 'locked'
        }, 
        lockable: {
            type: Boolean,
            default: undefined,
            kComposite: 'lockable'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeListColumn/Columns.js